import { ContactTypeEditPage } from "@/features/contact-type/pages/ContactTypeEdit";

const ContactTypeEdit = () => {
  return <ContactTypeEditPage />;
};

export default ContactTypeEdit;
